/**
 * Global voice session lock — prevents parallel ElevenLabs sessions.
 *
 * Only one voice session (Navigator OR AI meeting) can be active at a time.
 * Any component that starts an ElevenLabs session must acquire the lock first
 * and release it when the session ends.
 */

let activeSession: string | null = null
const listeners = new Set<() => void>()

export function acquireVoiceLock(sessionId: string): boolean {
  if (activeSession) return false
  activeSession = sessionId
  listeners.forEach(fn => fn())
  return true
}

export function releaseVoiceLock(sessionId: string): void {
  if (activeSession === sessionId) {
    activeSession = null
    listeners.forEach(fn => fn())
  }
}

export function isVoiceLocked(): boolean {
  return activeSession !== null
}

export function getActiveVoiceSession(): string | null {
  return activeSession
}

export function onVoiceLockChange(fn: () => void): () => void {
  listeners.add(fn)
  return () => listeners.delete(fn)
}
